"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../..");
var components_1 = require("../../components");
var button_1 = require("../../components/button/button");
var api_1 = require("../../api");
var EmailTemplatePage = /** @class */ (function (_super) {
    __extends(EmailTemplatePage, _super);
    function EmailTemplatePage(api, navigator, currentUserManager, recordId) {
        var _this = _super.call(this, __1.PageTypes.EmailTemplate, 'Email Template') || this;
        _this.api = api;
        _this.navigator = navigator;
        _this.currentUserManager = currentUserManager;
        _this.recordId = recordId;
        _this.showConfirmationPrompt = function () {
            _this.confirmationPrompt.show();
            _this.observationProvider.notifyObservers(__1.EmailTemplatePageActions.ConfirmationPromptShown);
        };
        _this.deleteTemplate = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.confirmationPrompt.deleteButton.setProcessing(true);
                        this.confirmationPrompt.cancelButton.setDisabled(true);
                        this.observationProvider.notifyObservers(__1.EmailTemplatePageActions.TemplateDeleting);
                        return [4 /*yield*/, this.api.delete(api_1.EndpointUrls.EmailTemplates, this.recordId)];
                    case 1:
                        _a.sent();
                        this.confirmationPrompt.deleteButton.setProcessing(false);
                        this.confirmationPrompt.cancelButton.setDisabled(false);
                        this.observationProvider.notifyObservers(__1.EmailTemplatePageActions.TemplateDeleted);
                        this.navigator.goToEmailTemplates();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.deleteTemplateCancelled = function () {
            _this.observationProvider.notifyObservers(__1.EmailTemplatePageActions.ConfirmationPromptCancelled);
        };
        _this.buildForm = function () {
            _this._templateContentField = new components_1.RichTextField('templateContent', '', false);
            _this._form = new __1.Form([
                new components_1.TextField('name', 'Name', true, 500, 'required'),
                new components_1.TextField('subject', 'Subject', true, 500, 'required'),
                _this._templateContentField
            ]);
        };
        _this.loadData = function () { return __awaiter(_this, void 0, void 0, function () {
            var templateData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._isLoading = true;
                        return [4 /*yield*/, this.api.get(api_1.EndpointUrls.EmailTemplates + '/' + this.recordId)];
                    case 1:
                        templateData = _a.sent();
                        this.form.setModel(templateData);
                        if (templateData.systemType) {
                            this.showConfirmationPromptButton.setVisibility(false);
                        }
                        this._isLoading = false;
                        this.observationProvider.notifyObservers(__1.EmailTemplatePageActions.DataLoaded);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.save = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.form.submit();
                        if (!this.form.isValid()) {
                            this.saveButton.setProcessing(false);
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.api.post(api_1.EndpointUrls.EmailTemplates, this.form.model)];
                    case 2:
                        _a.recordId = _b.sent();
                        this.form.model.id = this.recordId;
                        this.showConfirmationPromptButton.setVisibility(true);
                        this.alert.show({
                            alertType: components_1.AlertType.Success,
                            heading: 'Template Saved',
                            message: 'This template has been saved. Use the back button to return to the template list.'
                        });
                        this.saveButton.setProcessing(false);
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _b.sent();
                        this.saveButton.setProcessing(false);
                        this.alert.show({
                            alertType: components_1.AlertType.Error,
                            heading: 'Unable to save',
                            message: 'An error occurred trying to save the email template. Please contact your system administrator'
                        });
                        this.observationProvider.notifyObservers(__1.EmailTemplatePageActions.ErrorSaving);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.helpButton = new button_1.default({
            leftIcon: components_1.Icons.Question,
            onClick: function () { return _this.navigator.helpListModal.open(__1.HelpUrlType.EmailTemplateDetailPage); }
        });
        _this.observationProvider = new __1.ObservationProvider();
        _this.cancelButton = new button_1.default({
            onClick: _this.navigator.goToEmailTemplates,
            text: 'Back'
        });
        _this.saveButton = new button_1.default({
            onClick: _this.save,
            processingText: 'Saving...',
            text: 'Save'
        });
        _this.showConfirmationPromptButton = new button_1.default({
            leftIcon: components_1.Icons.Trash,
            onClick: _this.showConfirmationPrompt,
            isVisible: false
        });
        _this.confirmationPrompt = new components_1.ConfirmationPrompt(true, 'Delete Template', 'Are you sure you want to permanently delete this template?', 'Delete', 'Cancel', 'Deleting...');
        _this.confirmationPrompt.observationProvider.observe(_this.deleteTemplate, components_1.ConfirmationPromptActions.Confirmed);
        _this.confirmationPrompt.observationProvider.observe(_this.deleteTemplateCancelled, components_1.ConfirmationPromptActions.Cancelled);
        _this.buildForm();
        if (_this.recordId) {
            _this.loadData();
            _this.showConfirmationPromptButton.setVisibility(true);
        }
        return _this;
    }
    Object.defineProperty(EmailTemplatePage.prototype, "form", {
        get: function () {
            return this._form;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmailTemplatePage.prototype, "templateContentField", {
        get: function () {
            return this._templateContentField;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmailTemplatePage.prototype, "isLoading", {
        get: function () {
            return this._isLoading;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmailTemplatePage.prototype, "isApp", {
        get: function () {
            return this.currentUserManager.clientChecker.isMobileApp();
        },
        enumerable: false,
        configurable: true
    });
    return EmailTemplatePage;
}(__1.BasePage));
exports.default = EmailTemplatePage;
